import request from '@/utils/request'
const url = 'workOrder'

/** 获取工单列表 */
export function list(data) {
  return request({
    url: `${url}/list`,
    method: 'post',
    data
  })
}

/** 获取工单状态列表 */
export function getWorkOrderSelectList(data) {
  return request({
    url: `select/getWorkOrderSelectList`,
    method: 'post',
    data
  })
}

/** 获取工单时间轴 */
export function getDetail(data) {
  return request({
    url: `${url}/detail/${data}`,
    method: 'get'
  })
}

/** 获取工单详情 */
export function getWokOrderDetail(data) {
  return request({
    url: `${url}/getWokOrderDetail/${data}`,
    method: 'get'
  })
}

/** 获取工单维保项 */
export function getMaintenanceDetail(data) {
  return request({
    url: `${url}/maintenance/${data}`,
    method: 'get'
  })
}

/** 驳回工单 */
export function reject(data) {
  return request({
    url: `${url}/reject`,
    method: 'post',
    data
  })
}

/** 指派工单 */
export function assign(data) {
  return request({
    url: `${url}/assign`,
    method: 'post',
    data
  })
}

/** 工单取消 */
export function cancel(data) {
  return request({
    url: `${url}/cancel`,
    method: 'post',
    data
  })
}

/** 工单完成 */
export function finish(data) {
  return request({
    url: `${url}/finish`,
    method: 'post',
    data
  })
}

/** 获取指派用户下拉框 */
export function searchUser(data) {
  return request({
    url: `${url}/searchUser`,
    method: 'post',
    data
  })
}

/** 工单处理页面按钮权限控制 */
export function handleBtn(data) {
  return request({
    url: `${url}/handle/${data}`,
    method: 'get'
  })
}

/** 工单详情 - 备注、图片 */
export function detailById(data) {
  return request({
    url: `${url}/detailById/${data}`,
    method: 'get'
  })
}

/** 新增工单 */
export function insert(data) {
  return request({
    url: `${url}/insert`,
    method: 'post',
    data
  })
}

/** 首页代办工单列表 */
export function searchAgencyWorkOrderList(data) {
  return request({
    url: `${url}/searchAgencyWorkOrderList`,
    method: 'post',
    data
  })
}

/** 获取维保类型 */
export function getMaintenanceType(data) {
  return request({
    url: `${url}/maintenanceType`,
    method: 'get'
  })
}
